import Script from 'next/script'

const NaverPreLogPurchase = () => {
  return (
    <Script
      id="네이버프리미엄로그-구매전환"
      dangerouslySetInnerHTML={{
        __html: `
    var _nasa={}; 
    if(window.wcs) _nasa["cnv"] = wcs.cnv("1","10");
    `
      }}
    />
  )
}

export default NaverPreLogPurchase
